// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "267dc30fca84ce97","396": "e124eb0701ab9379","460": "f27111b9946e8359","498": "a50899231079940a","917": "64b17674ea5e3cf1","985": "1363819849162f6c",}[chunkId] + ".chunk.js"
}